import React from "react";

import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import { OrderDetails } from "features/OrderDetails";
import { PageTitle } from "shared/ui";

const TITLE = "Детали заказа";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/OrderDetails.
const OrderDetailsPage = () => {
    const { orderId } = useParams<{ orderId: string }>();

    return (
        <>
            <PageTitle>{`${TITLE} №${orderId}`}</PageTitle>
            <Helmet title={TITLE} />
            <OrderDetails />
        </>
    );
};

export default OrderDetailsPage;
